import { __extends } from "tslib";
import { PutAssociationWithTokenValidationInputFilterSensitiveLog, PutAssociationWithTokenValidationOutputFilterSensitiveLog, } from "../models/models_0";
import { deserializeAws_restJson1PutAssociationWithTokenValidationCommand, serializeAws_restJson1PutAssociationWithTokenValidationCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutAssociationWithTokenValidationCommand = (function (_super) {
    __extends(PutAssociationWithTokenValidationCommand, _super);
    function PutAssociationWithTokenValidationCommand(input) {
        var _this = _super.call(this) || this;
        _this.input = input;
        return _this;
    }
    PutAssociationWithTokenValidationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "GandalfLoginAssociationClient";
        var commandName = "PutAssociationWithTokenValidationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: PutAssociationWithTokenValidationInputFilterSensitiveLog,
            outputFilterSensitiveLog: PutAssociationWithTokenValidationOutputFilterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutAssociationWithTokenValidationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1PutAssociationWithTokenValidationCommand(input, context);
    };
    PutAssociationWithTokenValidationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1PutAssociationWithTokenValidationCommand(output, context);
    };
    return PutAssociationWithTokenValidationCommand;
}($Command));
export { PutAssociationWithTokenValidationCommand };
